import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import toastService from '../../../services/toastService';

class InspectionFindingsForm extends Form {
	state = {
		data: {
			findingsDescription: '',
			findingsLocation: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		findingsDescription: Joi.string().min(3).required().label('Description'),
		findingsLocation: Joi.string().min(3).required().label('Location'),
	};

	static propTypes = {
		initialFindingsDescription: PropTypes.string,
		initialFindingsLocation: PropTypes.string,
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onProceed({
			findingsDescription: this.state.data.findingsDescription,
			findingsLocation: this.state.data.findingsLocation,
		});

		toastService.success('Inspection Findings Updated Successfully!.');
	};

	componentDidMount() {
		this.setState({
			data: {
				findingsDescription: this.props.initialFindingsDescription ?? '',
				findingsLocation: this.props.initialFindingsLocation ?? '',
			},
		});
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderInput({
					type: 'text',
					name: 'findingsDescription',
					placeholder: 'Enter Description e.g TOPSIDE INSPECTION FINDINGS',
					label: 'Description',
				})}

				<div className="my-4 divider"></div>

				{this.renderInput({
					type: 'text',
					name: 'findingsLocation',
					placeholder: 'Enter Location e.g TRESTLE SECTION 1 (Axes 1 - 7)',
					label: 'Location',
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Inspection Findings')}
				</div>
			</form>
		);
	}
}

export default InspectionFindingsForm;
